// Copyright © Veeam Software Group GmbH

// eslint-disable-next-line @typescript-eslint/naming-convention
import { exploreSessionService } from '../exploreSessions';
import { ExplorePath } from './ExplorePath';

// eslint-disable-next-line @typescript-eslint/naming-convention
export type UniqueId = string & { __unique_id: never; };

export const getUniqueId = (id: string, version?: string, parent?: ExplorePath): UniqueId => {
    let result = id;
    const restorePoint = exploreSessionService.getRestorePoint();

    if (version) {
        result += `/${version}`;
    }

    if (restorePoint) {
        result += `/${restorePoint.id}`;
    }

    if (parent) {
        result += '__';
        parent.forEach((item) => {
            result += `/${item.title}`;
        })
    }

    return result as UniqueId;
};

export const removeRestorePointIdFromUniqueId = (uniqueId: string): string => {
    return uniqueId.split('/')[0];
};
